<template>
  <div class="login flex-column-center">
    <div class="login-box flex-column-between">
      <div class="title">Take Cloud</div>
      <el-form @submit.native.prevent :inline="true" :model="logindata" @submit.native.prevent class="login-form">
        <el-row>
          <el-col :span='10'>
            <el-form-item>
              <el-input v-on:keyup.enter.native="login" v-model="logindata.value" placeholder="手机号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='10'>
            <el-form-item>
              <el-input type="password" v-on:keyup.enter.native="login" v-model="logindata.password" placeholder="密码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='4'>
            <el-form-item>
              <el-button type="primary" @click.native="login">登陆</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        
        
        
      </el-form>
    </div>
    
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { post, get } from '@/utils/http';

export default {
  data() {
    return {
      logindata: {
        password: '',
        value: '',
        field: 'phone_no',
        loading: ''
      }
    }
  },
  computed: mapState(['callbackUrl']),
  mounted() {
    this.checkToken()
    this.loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading'
    });
  },
  methods: {
    ...mapActions(['updateUser']),
    async login() {
      if (!this.logindata.value) {
        this.$message.error('请填写手机号')
        return
      }
      if (!/^\d{9,11}$/.test(this.logindata.value)) {
        this.$message.error('手机号填写错误')
        return
      }
      if (!this.logindata.password) {
        this.$message.error('请填写密码')
        return
      }
      try {
        const res = await post('/user/Index/checkSignin', this.logindata)
        if (res && res.rst === 0) {
          this.checkToken()
          return
        }
        this.$message.error(res.msg || '账号或密码错误')
        this.loading.close()
      } catch(err) {
        this.loading.close()
      }
    },
    async checkToken() {
      try {
        const res = await get('/index/Common/getMyDetails')
        if (res && res.rst == 0) {
          this.updateUser({
            user_id: res.data.user_id,
            unit_id: res.data.unit_id,
            user_is_admin: res.data.user_is_admin,
            user_name: res.data.user_name,
            user_is_pta: res.data.user_is_pta,
            user_phone_no: res.data.user_phone_no
          })
          this.loading.close()
          this.$router.push({
            path: this.callbackUrl || '/'
          })
        }
      } catch(err) {
        this.loading.close()
      }
    }
  },
  name: 'login',
};
</script>
<style lang="less" scoped>
  .login {
    width: 100vw;
    height: 100vh;
    background: #324057;
    .login-box {
      height: 150px;
      width: 500px;
      margin-bottom: 300px;
      .title {
        text-align: center;
        color: #fff;
        font-size: 32px;
        font-weight: 700;
      }
    }
  }
</style>
